// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.MuiDataGrid-main
  > div.MuiDataGrid-virtualScroller
  > div.MuiDataGrid-topContainer
  > div.MuiDataGrid-columnHeaders
  > div
  > div.MuiDataGrid-columnHeader
  > div.MuiDataGrid-columnHeaderDraggableContainer {
  text-align: center;
}

div.MuiDataGrid-main
  > div.MuiDataGrid-virtualScroller
  > div.MuiDataGrid-topContainer
  > div.MuiDataGrid-columnHeaders
  > div
  > div.MuiDataGrid-columnHeader
  > div.MuiDataGrid-columnHeaderDraggableContainer
  > div.MuiDataGrid-columnHeaderTitleContainer {
  justify-content: center;
  padding: 5px 0 20px 0;
}

.MuiDataGrid-columnHeaderTitle {
  white-space: normal !important;            
  overflow: visible !important;       
  text-overflow: unset !important;    
  word-break: break-word;             
  display: -webkit-box !important;                
  -webkit-box-orient: vertical;      
}

div.MuiDataGrid-main
  > div.MuiDataGrid-virtualScroller
  > div.MuiDataGrid-topContainer
  > div.MuiDataGrid-columnHeaders
  > div
  > div.MuiDataGrid-columnHeader
  > div.MuiDataGrid-columnHeaderDraggableContainer
  > div.MuiDataGrid-columnHeaderTitleContainer
  > div.MuiDataGrid-columnHeaderTitleContainerContent
  > div.MuiDataGrid-columnHeaderTitle {
  font-weight: 900 !important;
}

div.searchbar-wrapper {
  border: 1px solid #0000001f;
  border-radius: 8px;
  padding: 10px;
  margin: 5px;
  background: #ffff;
  max-width: calc(100vw - 25px);
}
div.searchbar-container {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 5px;
  margin-bottom: 15px;
}

.worldmap__figure-container {
  margin: 0px;
}

div.MuiFormControl-root {
  padding: 0;
}

div.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall {
  height: 40px !important;
}

.span.MuiTypography-root.MuiListItemText-primary {
  float: inline-start;
}

.name {
  color: #1b5e20;
  font-size: 0.875rem;
  font-weight: 400;
  text-align: left;
}
.status {
  color: #1b5e20;
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}
.date {
  color: #1b5e20;
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}

.rejected_name {
  color: #fc0303;
  font-size: 0.875rem;
  font-weight: 400;
  text-align: left;
}
.rejected_status {
  color: #fc0303;
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}
.rejected_date {
  color: #fc0303;
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}

.pending_name {
  color: #ba5400;
  font-size: 0.875rem;
  font-weight: 400;
  text-align: left;
}
.pending_status {
  color: #ba5400;
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}
.sync_pending_status {
  color: #1565c0;
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}

div.MuiToolbar-root.MuiToolbar-gutters.MuiToolbar-regular {
  padding-left: 0;
  padding-right: 0;
}

div.past_subs_cancellation_count
  > div
  > div.ag-charts-wrapper
  > div.ag-charts-canvas-center
  > div.ag-charts-canvas-container
  > div.ag-charts-canvas {
  height: 120px;
}

button.ui-Button-disabled {
  color: #778899 !important;
}

.sidebar_item {
  border-radius: 8px;
  color: #ffffff;
}

.sidebar_item:hover {
  background-color: #f6f6f6;
  color: #1860f0;
}

.sidebar_item_selected {
  background-color: hsl(0, 0%, 96%);
  color: #1860f0;
}

.responsive-container {
  display: flex;
  flex-direction: column;
}
.responsive-row-1 {
  min-height: 655px;
}
.responsive-item {
  width: 100%;
  border: 1px solid #0000001f;
  border-radius: 8px;
  padding: 5px;
  margin: 5px;
  background: #ffff;
  max-width: calc(100vw - 25px);
}
.responsive-item-product-catalogue {
  height: 110vh;
  width: 100%;
  border: 1px solid #0000001f;
  border-radius: 8px;
  padding: 5px;
  margin: 5px;
  background: #ffff;
  max-width: calc(100vw - 25px);
}
div.responsive-item:nth-child(1) {
  flex: 0.55;
}
div.responsive-item:nth-child(2) {
  flex: 0.45;
}

.responsive-item-pending-days {
  padding: 5px;
  margin: 5px;
  background: #ffff;
}

.top-bar-list {
  display: ruby;
  margin: 0;
}

div.dashboard-top-bar-container {
  display: flex !important;
  position: relative !important;
  min-height: 75px !important;
}

/* responsive app height starts */
@media (min-width: 0px) and (max-width: 374px) {
  div.dashboard-top-bar-container {
    min-height: 260px !important;
  }
}
@media (min-width: 375px) and (max-width: 389px) {
  div.dashboard-top-bar-container {
    min-height: 200px !important;
  }
}
@media (min-width: 390px) and (max-width: 400px) {
  div.dashboard-top-bar-container {
    min-height: 200px !important;
  }
}
@media (min-width: 401px) and (max-width: 415px) {
  div.dashboard-top-bar-container {
    min-height: 140px !important;
  }
}
@media (min-width: 416px) and (max-width: 438px) {
  div.dashboard-top-bar-container {
    min-height: 140px !important;
  }
}
@media (min-width: 439px) and (max-width: 453px) {
  div.dashboard-top-bar-container {
    min-height: 75px !important;
  }
}
@media (min-width: 454px) and (max-width: 590px) {
  div.dashboard-top-bar-container {
    min-height: 75px !important;
  }
}
@media (min-width: 591px) and (max-width: 605px) {
  div.dashboard-top-bar-container {
    min-height: 25px !important;
  }
}
@media (min-width: 606px) and (max-width: 630px) {
  div.dashboard-top-bar-container {
    min-height: 20px !important;
  }
}
@media (min-width: 729px) and (max-width: 844px) {
  div.dashboard-top-bar-container {
    min-height: 75px !important;
  }
}
@media (min-width: 845px) and (max-width: 855px) {
  div.dashboard-top-bar-container {
    min-height: 135px !important;
  }
}
@media (min-width: 856px) and (max-width: 870px) {
  div.dashboard-top-bar-container {
    min-height: 75px !important;
  }
}
@media (min-width: 1499px) and (max-width: 1558px) {
  div.dashboard-top-bar-container {
    min-height: 15px !important;
  }
}
/* responsive app height ends */

@media (min-width: 0px) {
  .appbar_container
    > .MuiPaper-root.MuiPaper-elevation
    > .MuiToolbar-root.MuiToolbar-gutters {
    padding-left: 0px;
  }

  div.nav_item_container {
    display: flex;
  }

  .dashboard-top-bar {
    top: 58px !important;
  }

  .cancellation-approval-rejection-box {
    width: 380px;
  }

  .product-catalog-action-failure-box {
    width: 380px;
  }
}

@media (min-width: 600px) {
  .appbar_container
    > .MuiPaper-root.MuiPaper-elevation
    > .MuiToolbar-root.MuiToolbar-gutters {
    padding-left: 0px;
  }

  div.nav_item_container {
    display: flex;
  }

  .dashboard-top-bar {
    top: 58px !important;
  }

  .cancellation-approval-rejection-box {
    width: 550px;
  }

  .product-catalog-action-failure-box {
    width: 550px;
  }
}

@media (min-width: 1024px) {
  .responsive-container {
    flex-direction: row;
  }

  .responsive-item {
    width: 50%;
  }

  .cancellation-approval-rejection-box {
    width: 810px;
  }

  .product-catalog-action-failure-box {
    width: 1500px;
  }
}

@media (min-width: 0px) and (max-width: 600px) {
  div.table_container {
    top: 190px;
  }
}

@media (min-width: 600px) and (max-width: 631px) {
  div.table_container {
    top: 185px;
  }
}

@media (min-width: 631px) and (max-width: 845px) {
  div.table_container {
    top: 120px;
  }
}

@media (min-width: 845px) and (max-width: 1558px) {
  div.table_container {
    top: 60px;
  }
}

/* mobile (max-width 768px) */
@media only screen and (max-width: 768px) {
  div.searchbar-container {
    display: grid;
  }

  div.searchbar-container > div.MuiBox-root {
    display: flex;
    gap: 10px;
  }
}

button.apprv_rjct_btn {
  white-space: normal !important;
  font-size: 15px !important;
  font-weight: 320;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  padding: 1% !important;
  height: 45px !important;
  width: 25% !important;
  max-width: 210px;
  min-width: 142px !important;
}

button.apprv_rjct_btn.popup {
  width: 100% !important;
  min-width: 200px !important;
}

.ag-chart-tooltip-container {
  display: flex;
}

.show-all-text {
  color: #00000099;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  text-align: left;
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
}

input.PrivateSwitchBase-input.MuiSwitch-input {
  left: 0;
  width: 100%;
}

p.approver-cell {
  width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

div.user-info-popover
  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {
  background: transparent;
  top: 53px !important;
  width: 311px !important;

  div.MuiBox-root {
    top: 2.5%;
  }
}

div.user-info-popover
  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {
  border-radius: 8px;
}

div.user-info-popover.four
  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {
  height: 185px !important;
}
div.user-info-popover.three
  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {
  height: 127px !important;
}
div.user-info-popover.two
  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {
  height: 88px !important;
}
div.user-info-popover.one
  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {
  height: 68px !important;
}

.table-header-ellipsis {
  white-space: normal;      
  word-wrap: break-word;    
  overflow-wrap: break-word;
  overflow: visible;        
  text-overflow: unset;     
}

div.user-info-popover {
  .email {
    align-content: flex-end;
    color: #2f4f4f !important;
    font-weight: bold !important;
    font-size: 0.75rem;
  }
}

.dashboard-topbar-text > span {
  font-size: 14.4px;
  white-space: nowrap;
}

.dashboard-top-bar {
  top: 62px;
}

.operations-datagrid-cell {
  position: relative;
}

.operations-datagrid-cell::before {
  content: "";
  position: absolute;
  top: 25px;
  left: 0;
  width: 0.75px;
  height: 25%;
  background-color: #e0e0e0;
  z-index: 1;
}

.operations-datagrid-cell:nth-child(2)::before {
  border: 1px solid white;
}

textarea[placeholder="Please enter additional comments"] {
  display: block !important;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
  -ms-flex-negative: 0;
}

div.MuiToolbar-root.MuiToolbar-gutters.MuiToolbar-regular.MuiTablePagination-toolbar
  > div.MuiTablePagination-actions {
  flex-shrink: 0;
  margin-left: 20px;
  margin-right: 60px;
}

div.promised-pay-date-picker.select_label.MuiFormControl-root.MuiTextField-root {
  border: 0;
  vertical-align: top;
  margin: 8px 0;
  width: 300px;
  margin-right: 20px;
}

.select_label
  > label.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink {
  color: #2f4f4f !important;
  font-weight: bold !important;
}

.select_label
  > div.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedEnd {
  height: 40px;
}

.select_label
  > div
  > input.MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd {
  font-size: 0.8rem;
}

.select_label[data-shrink="true"] {
  color: #2f4f4f !important;
  font-weight: bold !important;
}

.select_label[data-shrink="false"] {
  color: #2f4f4f !important;
  font-weight: bold !important;
  font-size: 0.85rem;
  top: 5px;
}

.promised-pay-date-container {
  display: flex;
}

.promised-pay-date-radio
  > label
  > span.MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label {
  font-size: 0.9rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}

div.MuiDataGrid-row--borderBottom {
  background-color: #f1f4f6 !important;
}

div.cancellation-approval-rejection-modal > div.MuiBox-root {
  padding: 20px;
}

div.product-catalog-action-failure-modal > div.MuiBox-root {
  padding: 20px;
}

.table_container {
  display: flex;
  background: #f6f6f6;
  position: relative;
}

.search_input_container {
  width: -webkit-fill-available;
}

.search_input_container_product_catalogue {
  width: 30%;
}

.search_input,
.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedEnd {
  border-radius: 10px;
  height: 40px;
}

.search_input > span {
  height: 40px !important;
}

.cell_custom_badge {
  padding: 6px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}

.nav-logo {
  height: 30px;
  margin-left: 10px;
  margin-right: 10px;
  animation: fade-in 1s ease-in-out;
}

.nav-separator {
  height: 20px;
  width: 1px;
  background-color: #ccc;
  margin: 0 10px;
}

span.cell_custom_badge,
div.sidebar_item:hover,
div.sidebar_item_selected,
/* hide row shadow on hover */
/* div.MuiDataGrid-row:hover, */
span.MuiSwitch-root:hover,
div.responsive-item:hover,
div.searchbar-wrapper:hover,
div.MuiAvatar-root.MuiAvatar-circular,
button.cancellation-table-export-btn:hover,
span.MuiButtonBase-root.MuiRadio-root:hover,
div.cancellation-table-export-datepicker:hover,
div.MuiInputBase-root.MuiOutlinedInput-root:hover,
button.MuiButtonBase-root.MuiFab-root.MuiFab-circular,
button.MuiButtonBase-root.MuiButton-root:not(.ui-Button-disabled):hover,
div.MuiTablePagination-actions
  > button.MuiButtonBase-root.MuiIconButton-root:not(.Mui-disabled):hover {
  box-shadow: 4px 4px 10px #0000004d;
  transition: box-shadow 0.3s ease-in-out;
}

div.MuiDataGrid-row:hover {
  background: #fbfbfb !important;
}

.datagrid-parent-container {
  display: flex;
  min-width: 100%;
}

.cancellation-approval-rejection-box {
  padding: 20px;
  position: relative;
}

.product-catalog-action-failure-box {
  padding: 20px;
  position: relative;
}

header.dashboard-title-bar,
header.dashboard-top-bar {
  font-size: 2.5rem;
  box-shadow: 0 10px 20px #0000004d;
}

.dashboard-toolbar {
  justify-content: space-between;
  background: #4285f4;
  display: grid;
}

.dashboard-toolbar-container {
  position: relative;
  width: 100%;
}

h6.operations-container-title {
  font-weight: bold;
  color: #384988;
}

.operations-3d-title,
div.sidebar_item_selected {
  /* text-shadow: 2px 2px 4px #00000026; */
  /* transform: translateZ(10px); */
}

.operations-3d-title:hover {
  /* text-shadow: 2px 2px 4px #0000004d; */
}

.loader-container {
  background: #ffff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  max-width: calc(100vw - 25px);
}

.tile-centralise-content {
  background: #ffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
}

.animated-title {
  position: relative;
  animation: slide-up 0.5s ease-in-out forwards;
  opacity: 0;
}

.animated-signin-btn {
  position: relative;
  animation: slide-down 0.5s ease-in-out forwards;
  opacity: 0;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translateY(80px); /* Starting position */
  }
  100% {
    opacity: 1;
    transform: translateY(0); /* Final position */
  }
}

@keyframes slide-down {
  0% {
    opacity: 0;
    transform: translateY(-80px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.show-all-text,
.aging-table-search-form > label,
.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink.MuiInputLabel-sizeMedium.MuiInputLabel-outlined.MuiFormLabel-colorPrimary.MuiFormLabel-filled.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink.MuiInputLabel-sizeMedium.MuiInputLabel-outlined {
  min-width: 52px;
  color: #2f4f4f !important;
  font-weight: bold !important;
}

div.cancellation-table-export-datepicker {
  border-radius: 10px;
  background: transparent !important;
}
div.cancellation-table-export-datepicker:hover {
  border: 1px solid #000;
}

input.MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd {
  min-width: 100px;
}

.status-cell-center.MuiDataGrid-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;;;;;;;;;EAUE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA,+BAA+B;;AAE/B;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uDAAuD;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;;EAEvB;IACE,SAAS;EACX;AACF;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;EAiBE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B,EAAE,sBAAsB;EACrD;EACA;IACE,UAAU;IACV,wBAAwB,EAAE,mBAAmB;EAC/C;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;EAGE,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["div.MuiDataGrid-main\n  > div.MuiDataGrid-virtualScroller\n  > div.MuiDataGrid-topContainer\n  > div.MuiDataGrid-columnHeaders\n  > div\n  > div.MuiDataGrid-columnHeader\n  > div.MuiDataGrid-columnHeaderDraggableContainer {\n  text-align: center;\n}\n\ndiv.MuiDataGrid-main\n  > div.MuiDataGrid-virtualScroller\n  > div.MuiDataGrid-topContainer\n  > div.MuiDataGrid-columnHeaders\n  > div\n  > div.MuiDataGrid-columnHeader\n  > div.MuiDataGrid-columnHeaderDraggableContainer\n  > div.MuiDataGrid-columnHeaderTitleContainer {\n  justify-content: center;\n  padding: 5px 0 20px 0;\n}\n\n.MuiDataGrid-columnHeaderTitle {\n  white-space: normal !important;            \n  overflow: visible !important;       \n  text-overflow: unset !important;    \n  word-break: break-word;             \n  display: -webkit-box !important;                \n  -webkit-box-orient: vertical;      \n}\n\ndiv.MuiDataGrid-main\n  > div.MuiDataGrid-virtualScroller\n  > div.MuiDataGrid-topContainer\n  > div.MuiDataGrid-columnHeaders\n  > div\n  > div.MuiDataGrid-columnHeader\n  > div.MuiDataGrid-columnHeaderDraggableContainer\n  > div.MuiDataGrid-columnHeaderTitleContainer\n  > div.MuiDataGrid-columnHeaderTitleContainerContent\n  > div.MuiDataGrid-columnHeaderTitle {\n  font-weight: 900 !important;\n}\n\ndiv.searchbar-wrapper {\n  border: 1px solid #0000001f;\n  border-radius: 8px;\n  padding: 10px;\n  margin: 5px;\n  background: #ffff;\n  max-width: calc(100vw - 25px);\n}\ndiv.searchbar-container {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 5px;\n  margin-bottom: 15px;\n}\n\n.worldmap__figure-container {\n  margin: 0px;\n}\n\ndiv.MuiFormControl-root {\n  padding: 0;\n}\n\ndiv.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall {\n  height: 40px !important;\n}\n\n.span.MuiTypography-root.MuiListItemText-primary {\n  float: inline-start;\n}\n\n.name {\n  color: #1b5e20;\n  font-size: 0.875rem;\n  font-weight: 400;\n  text-align: left;\n}\n.status {\n  color: #1b5e20;\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n}\n.date {\n  color: #1b5e20;\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n}\n\n.rejected_name {\n  color: #fc0303;\n  font-size: 0.875rem;\n  font-weight: 400;\n  text-align: left;\n}\n.rejected_status {\n  color: #fc0303;\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n}\n.rejected_date {\n  color: #fc0303;\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n}\n\n.pending_name {\n  color: #ba5400;\n  font-size: 0.875rem;\n  font-weight: 400;\n  text-align: left;\n}\n.pending_status {\n  color: #ba5400;\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n}\n.sync_pending_status {\n  color: #1565c0;\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n}\n\ndiv.MuiToolbar-root.MuiToolbar-gutters.MuiToolbar-regular {\n  padding-left: 0;\n  padding-right: 0;\n}\n\ndiv.past_subs_cancellation_count\n  > div\n  > div.ag-charts-wrapper\n  > div.ag-charts-canvas-center\n  > div.ag-charts-canvas-container\n  > div.ag-charts-canvas {\n  height: 120px;\n}\n\nbutton.ui-Button-disabled {\n  color: #778899 !important;\n}\n\n.sidebar_item {\n  border-radius: 8px;\n  color: #ffffff;\n}\n\n.sidebar_item:hover {\n  background-color: #f6f6f6;\n  color: #1860f0;\n}\n\n.sidebar_item_selected {\n  background-color: hsl(0, 0%, 96%);\n  color: #1860f0;\n}\n\n.responsive-container {\n  display: flex;\n  flex-direction: column;\n}\n.responsive-row-1 {\n  min-height: 655px;\n}\n.responsive-item {\n  width: 100%;\n  border: 1px solid #0000001f;\n  border-radius: 8px;\n  padding: 5px;\n  margin: 5px;\n  background: #ffff;\n  max-width: calc(100vw - 25px);\n}\n.responsive-item-product-catalogue {\n  height: 110vh;\n  width: 100%;\n  border: 1px solid #0000001f;\n  border-radius: 8px;\n  padding: 5px;\n  margin: 5px;\n  background: #ffff;\n  max-width: calc(100vw - 25px);\n}\ndiv.responsive-item:nth-child(1) {\n  flex: 0.55;\n}\ndiv.responsive-item:nth-child(2) {\n  flex: 0.45;\n}\n\n.responsive-item-pending-days {\n  padding: 5px;\n  margin: 5px;\n  background: #ffff;\n}\n\n.top-bar-list {\n  display: ruby;\n  margin: 0;\n}\n\ndiv.dashboard-top-bar-container {\n  display: flex !important;\n  position: relative !important;\n  min-height: 75px !important;\n}\n\n/* responsive app height starts */\n@media (min-width: 0px) and (max-width: 374px) {\n  div.dashboard-top-bar-container {\n    min-height: 260px !important;\n  }\n}\n@media (min-width: 375px) and (max-width: 389px) {\n  div.dashboard-top-bar-container {\n    min-height: 200px !important;\n  }\n}\n@media (min-width: 390px) and (max-width: 400px) {\n  div.dashboard-top-bar-container {\n    min-height: 200px !important;\n  }\n}\n@media (min-width: 401px) and (max-width: 415px) {\n  div.dashboard-top-bar-container {\n    min-height: 140px !important;\n  }\n}\n@media (min-width: 416px) and (max-width: 438px) {\n  div.dashboard-top-bar-container {\n    min-height: 140px !important;\n  }\n}\n@media (min-width: 439px) and (max-width: 453px) {\n  div.dashboard-top-bar-container {\n    min-height: 75px !important;\n  }\n}\n@media (min-width: 454px) and (max-width: 590px) {\n  div.dashboard-top-bar-container {\n    min-height: 75px !important;\n  }\n}\n@media (min-width: 591px) and (max-width: 605px) {\n  div.dashboard-top-bar-container {\n    min-height: 25px !important;\n  }\n}\n@media (min-width: 606px) and (max-width: 630px) {\n  div.dashboard-top-bar-container {\n    min-height: 20px !important;\n  }\n}\n@media (min-width: 729px) and (max-width: 844px) {\n  div.dashboard-top-bar-container {\n    min-height: 75px !important;\n  }\n}\n@media (min-width: 845px) and (max-width: 855px) {\n  div.dashboard-top-bar-container {\n    min-height: 135px !important;\n  }\n}\n@media (min-width: 856px) and (max-width: 870px) {\n  div.dashboard-top-bar-container {\n    min-height: 75px !important;\n  }\n}\n@media (min-width: 1499px) and (max-width: 1558px) {\n  div.dashboard-top-bar-container {\n    min-height: 15px !important;\n  }\n}\n/* responsive app height ends */\n\n@media (min-width: 0px) {\n  .appbar_container\n    > .MuiPaper-root.MuiPaper-elevation\n    > .MuiToolbar-root.MuiToolbar-gutters {\n    padding-left: 0px;\n  }\n\n  div.nav_item_container {\n    display: flex;\n  }\n\n  .dashboard-top-bar {\n    top: 58px !important;\n  }\n\n  .cancellation-approval-rejection-box {\n    width: 380px;\n  }\n\n  .product-catalog-action-failure-box {\n    width: 380px;\n  }\n}\n\n@media (min-width: 600px) {\n  .appbar_container\n    > .MuiPaper-root.MuiPaper-elevation\n    > .MuiToolbar-root.MuiToolbar-gutters {\n    padding-left: 0px;\n  }\n\n  div.nav_item_container {\n    display: flex;\n  }\n\n  .dashboard-top-bar {\n    top: 58px !important;\n  }\n\n  .cancellation-approval-rejection-box {\n    width: 550px;\n  }\n\n  .product-catalog-action-failure-box {\n    width: 550px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .responsive-container {\n    flex-direction: row;\n  }\n\n  .responsive-item {\n    width: 50%;\n  }\n\n  .cancellation-approval-rejection-box {\n    width: 810px;\n  }\n\n  .product-catalog-action-failure-box {\n    width: 1500px;\n  }\n}\n\n@media (min-width: 0px) and (max-width: 600px) {\n  div.table_container {\n    top: 190px;\n  }\n}\n\n@media (min-width: 600px) and (max-width: 631px) {\n  div.table_container {\n    top: 185px;\n  }\n}\n\n@media (min-width: 631px) and (max-width: 845px) {\n  div.table_container {\n    top: 120px;\n  }\n}\n\n@media (min-width: 845px) and (max-width: 1558px) {\n  div.table_container {\n    top: 60px;\n  }\n}\n\n/* mobile (max-width 768px) */\n@media only screen and (max-width: 768px) {\n  div.searchbar-container {\n    display: grid;\n  }\n\n  div.searchbar-container > div.MuiBox-root {\n    display: flex;\n    gap: 10px;\n  }\n}\n\nbutton.apprv_rjct_btn {\n  white-space: normal !important;\n  font-size: 15px !important;\n  font-weight: 320;\n  word-wrap: break-word !important;\n  overflow-wrap: break-word !important;\n  padding: 1% !important;\n  height: 45px !important;\n  width: 25% !important;\n  max-width: 210px;\n  min-width: 142px !important;\n}\n\nbutton.apprv_rjct_btn.popup {\n  width: 100% !important;\n  min-width: 200px !important;\n}\n\n.ag-chart-tooltip-container {\n  display: flex;\n}\n\n.show-all-text {\n  color: #00000099;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-size: 0.75rem;\n  text-align: left;\n  margin-top: 0;\n  margin-right: 0;\n  margin-bottom: 0;\n  margin-left: 0;\n}\n\ninput.PrivateSwitchBase-input.MuiSwitch-input {\n  left: 0;\n  width: 100%;\n}\n\np.approver-cell {\n  width: fit-content;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\ndiv.user-info-popover\n  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {\n  background: transparent;\n  top: 53px !important;\n  width: 311px !important;\n\n  div.MuiBox-root {\n    top: 2.5%;\n  }\n}\n\ndiv.user-info-popover\n  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {\n  border-radius: 8px;\n}\n\ndiv.user-info-popover.four\n  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {\n  height: 185px !important;\n}\ndiv.user-info-popover.three\n  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {\n  height: 127px !important;\n}\ndiv.user-info-popover.two\n  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {\n  height: 88px !important;\n}\ndiv.user-info-popover.one\n  > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper {\n  height: 68px !important;\n}\n\n.table-header-ellipsis {\n  white-space: normal;      \n  word-wrap: break-word;    \n  overflow-wrap: break-word;\n  overflow: visible;        \n  text-overflow: unset;     \n}\n\ndiv.user-info-popover {\n  .email {\n    align-content: flex-end;\n    color: #2f4f4f !important;\n    font-weight: bold !important;\n    font-size: 0.75rem;\n  }\n}\n\n.dashboard-topbar-text > span {\n  font-size: 14.4px;\n  white-space: nowrap;\n}\n\n.dashboard-top-bar {\n  top: 62px;\n}\n\n.operations-datagrid-cell {\n  position: relative;\n}\n\n.operations-datagrid-cell::before {\n  content: \"\";\n  position: absolute;\n  top: 25px;\n  left: 0;\n  width: 0.75px;\n  height: 25%;\n  background-color: #e0e0e0;\n  z-index: 1;\n}\n\n.operations-datagrid-cell:nth-child(2)::before {\n  border: 1px solid white;\n}\n\ntextarea[placeholder=\"Please enter additional comments\"] {\n  display: block !important;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.43;\n  letter-spacing: 0.01071em;\n  -ms-flex-negative: 0;\n}\n\ndiv.MuiToolbar-root.MuiToolbar-gutters.MuiToolbar-regular.MuiTablePagination-toolbar\n  > div.MuiTablePagination-actions {\n  flex-shrink: 0;\n  margin-left: 20px;\n  margin-right: 60px;\n}\n\ndiv.promised-pay-date-picker.select_label.MuiFormControl-root.MuiTextField-root {\n  border: 0;\n  vertical-align: top;\n  margin: 8px 0;\n  width: 300px;\n  margin-right: 20px;\n}\n\n.select_label\n  > label.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink {\n  color: #2f4f4f !important;\n  font-weight: bold !important;\n}\n\n.select_label\n  > div.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedEnd {\n  height: 40px;\n}\n\n.select_label\n  > div\n  > input.MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd {\n  font-size: 0.8rem;\n}\n\n.select_label[data-shrink=\"true\"] {\n  color: #2f4f4f !important;\n  font-weight: bold !important;\n}\n\n.select_label[data-shrink=\"false\"] {\n  color: #2f4f4f !important;\n  font-weight: bold !important;\n  font-size: 0.85rem;\n  top: 5px;\n}\n\n.promised-pay-date-container {\n  display: flex;\n}\n\n.promised-pay-date-radio\n  > label\n  > span.MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label {\n  font-size: 0.9rem;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n}\n\ndiv.MuiDataGrid-row--borderBottom {\n  background-color: #f1f4f6 !important;\n}\n\ndiv.cancellation-approval-rejection-modal > div.MuiBox-root {\n  padding: 20px;\n}\n\ndiv.product-catalog-action-failure-modal > div.MuiBox-root {\n  padding: 20px;\n}\n\n.table_container {\n  display: flex;\n  background: #f6f6f6;\n  position: relative;\n}\n\n.search_input_container {\n  width: -webkit-fill-available;\n}\n\n.search_input_container_product_catalogue {\n  width: 30%;\n}\n\n.search_input,\n.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedEnd {\n  border-radius: 10px;\n  height: 40px;\n}\n\n.search_input > span {\n  height: 40px !important;\n}\n\n.cell_custom_badge {\n  padding: 6px 10px;\n  border-radius: 15px;\n  font-size: 12px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.nav-logo {\n  height: 30px;\n  margin-left: 10px;\n  margin-right: 10px;\n  animation: fade-in 1s ease-in-out;\n}\n\n.nav-separator {\n  height: 20px;\n  width: 1px;\n  background-color: #ccc;\n  margin: 0 10px;\n}\n\nspan.cell_custom_badge,\ndiv.sidebar_item:hover,\ndiv.sidebar_item_selected,\n/* hide row shadow on hover */\n/* div.MuiDataGrid-row:hover, */\nspan.MuiSwitch-root:hover,\ndiv.responsive-item:hover,\ndiv.searchbar-wrapper:hover,\ndiv.MuiAvatar-root.MuiAvatar-circular,\nbutton.cancellation-table-export-btn:hover,\nspan.MuiButtonBase-root.MuiRadio-root:hover,\ndiv.cancellation-table-export-datepicker:hover,\ndiv.MuiInputBase-root.MuiOutlinedInput-root:hover,\nbutton.MuiButtonBase-root.MuiFab-root.MuiFab-circular,\nbutton.MuiButtonBase-root.MuiButton-root:not(.ui-Button-disabled):hover,\ndiv.MuiTablePagination-actions\n  > button.MuiButtonBase-root.MuiIconButton-root:not(.Mui-disabled):hover {\n  box-shadow: 4px 4px 10px #0000004d;\n  transition: box-shadow 0.3s ease-in-out;\n}\n\ndiv.MuiDataGrid-row:hover {\n  background: #fbfbfb !important;\n}\n\n.datagrid-parent-container {\n  display: flex;\n  min-width: 100%;\n}\n\n.cancellation-approval-rejection-box {\n  padding: 20px;\n  position: relative;\n}\n\n.product-catalog-action-failure-box {\n  padding: 20px;\n  position: relative;\n}\n\nheader.dashboard-title-bar,\nheader.dashboard-top-bar {\n  font-size: 2.5rem;\n  box-shadow: 0 10px 20px #0000004d;\n}\n\n.dashboard-toolbar {\n  justify-content: space-between;\n  background: #4285f4;\n  display: grid;\n}\n\n.dashboard-toolbar-container {\n  position: relative;\n  width: 100%;\n}\n\nh6.operations-container-title {\n  font-weight: bold;\n  color: #384988;\n}\n\n.operations-3d-title,\ndiv.sidebar_item_selected {\n  /* text-shadow: 2px 2px 4px #00000026; */\n  /* transform: translateZ(10px); */\n}\n\n.operations-3d-title:hover {\n  /* text-shadow: 2px 2px 4px #0000004d; */\n}\n\n.loader-container {\n  background: #ffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  max-width: calc(100vw - 25px);\n}\n\n.tile-centralise-content {\n  background: #ffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 500px;\n}\n\n.animated-title {\n  position: relative;\n  animation: slide-up 0.5s ease-in-out forwards;\n  opacity: 0;\n}\n\n.animated-signin-btn {\n  position: relative;\n  animation: slide-down 0.5s ease-in-out forwards;\n  opacity: 0;\n}\n\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes slide-up {\n  0% {\n    opacity: 0;\n    transform: translateY(80px); /* Starting position */\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0); /* Final position */\n  }\n}\n\n@keyframes slide-down {\n  0% {\n    opacity: 0;\n    transform: translateY(-80px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.show-all-text,\n.aging-table-search-form > label,\n.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink.MuiInputLabel-sizeMedium.MuiInputLabel-outlined.MuiFormLabel-colorPrimary.MuiFormLabel-filled.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink.MuiInputLabel-sizeMedium.MuiInputLabel-outlined {\n  min-width: 52px;\n  color: #2f4f4f !important;\n  font-weight: bold !important;\n}\n\ndiv.cancellation-table-export-datepicker {\n  border-radius: 10px;\n  background: transparent !important;\n}\ndiv.cancellation-table-export-datepicker:hover {\n  border: 1px solid #000;\n}\n\ninput.MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd {\n  min-width: 100px;\n}\n\n.status-cell-center.MuiDataGrid-cell {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
